import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const prefixUrl = "evalteachercourse/"; 

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},

    {key:'batchNo', label: '批次', width: 130},
    {key:'orgName', label: '部门', width: 150},
    {key:'targetName', label: '评价项目', width: 120},
    {key:'loginName', label: '登陆账号', width: 100},
    {key:'employeeName', label: '教师姓名', width: 90},
    {key:'classesName', label: '班级名称', width: 120},
    {key:'courseName', label: '课程名称', width: 120},
    {key:'currentTimes', label: '已评次数' , width: 90},
    {key:'limitedTimes', label: '可评次数', width: 90},
    {key:'expiredDate', label: '截止日期', width: 100},
    {key:'termName', label: '所属学期/学年'},
]);





/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(prefixUrl + 'list?' + params.join('&'),  Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta,
        };
    })
    .then(response => (Object.assign({
        result: response.data.dataList || [],
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...',
        meta: response.meta
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post(prefixUrl + 'add', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '信息添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到管理页面！</p>
                    </div>
                ),
                onOk() {
                    window.location.hash = 'studentCourse/index';
                },
                okText:"确认",
            });
        }
    }).catch(error => {
        // console.log('error');
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const querySearchByExpiredDate = () => {
    return fetch.get(prefixUrl + 'getBatchNo')
    .then(response => {
        return response.payload.data;
    }).catch(error => {
        // console.log(error);
    });
}

/**
 * @method update
 * @param {object} data
 * @return {promise}
 */
const update = (data) => {
    return fetch.post(prefixUrl + 'updateExpiredDate', data)
    .then(response => {
        if(response.code === 200) {
            message.success('信息更新成功!');
        }
    }).catch(error => {
        // console.log(error);
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post(prefixUrl + 'remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    return new Promise(function(resolve, reject) {
        if(DataGrid.selections.length === 0) {
            // Modal.error({
            //     title: '请先选择一项或多项！',
            //     content: '只有勾选一项或多项后才能删除！',
            // });
            Modal.confirm({
                title: '确认删除全部？',
                content: '没有选择数据，将删除当前学期全部数据',
                onOk: () => {
                    Modal.confirm({
                        title: '再次确认是否删除全部数据？',
                        content: '点击确认删除当前学期全部数据',
                        onOk: () => {
                            remove([]).then(response => {
                                if(response.code === 200) {
                                    message.success(response.message);
                                    callback();
                                } else {
                                    Modal.error({
                                        title: '消息',
                                        content: response.message,
                                        okText: '确认'
                                    })
                                }
                            });
                        },
                        okText:"确认",
                        cancelText:"取消"
                    })
                },
                okText:"确认",
                cancelText:"取消"
            });
        } else {
            Modal.confirm({
                title: '确定删除该记录？',
                content: '删除后将无法恢复！',
                onOk() {
                    remove(DataGrid.selections).then(response => {
                        if(response.code === 200) {
                            message.success(response.message);
                            resolve();
                            callback();
                        } else {
                            reject();
                        }
                    });
                },
                onCancel() {},
                okText:"确认",
                cancelText:"取消"
            });
        }
    })
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'studentCourse'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    insert,
    querySearch,
    remove,
    update,
    headers,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    redirect,
    getSelection,
    getSelectionData,
    querySearchByExpiredDate
}